define('rebrush/components/csp/product/download/item',[
    'jquery',
    'lodash',
    'cartware/components/_base',
    'cartware/jquery/bem',
    'rebrush/system/layout/responsive-hub',
    'rebrush/system/animation',
    'cartware/polyfill/requestAnimationFrame'
], function(
    $,
    _,
    Component,
    BEM,
    ResponsiveHub,
    Animation
) {
    var BLOCK_CLASSNAME         = BEM.buildBlockClassname('csp-product-download-item'),
        ELEMENT_TITLE_CLASSNAME = BEM.buildElementClassname('csp-product-download-item', 'title'),
        MODIFIER_OPENING        = 'opening',
        MODIFIER_OPEN           = 'open';

    var isMobile = true;
    var endPrecedingAnimation = $.noop;

    return Component.create({
        $init: function() {
            $(document.body).on('click', '.' + ELEMENT_TITLE_CLASSNAME, _.bind(this.onTitleClick, this));
            $('.' + ELEMENT_TITLE_CLASSNAME).on('click', _.bind(this.onTitleClick, this));
            ResponsiveHub
                .on('change.mobile.enter', function() { isMobile = true; })
                .on('change.mobile.leave', function() { isMobile = false; });
        },

        onTitleClick: function(e) {
            var title = $(e.currentTarget),
                block = BEM.block(title.closest('.' + BLOCK_CLASSNAME)),
                content = block.getElements('content');

            if (content.length) {
                e.preventDefault();

                if (block.bemHasModifier('open')) {
                    this.closeItem(block, content);
                } else {
                    this.openItem(block, content);
                }
            }
        },

        openItem: function(block, content) {
            var onFrame = function() {
                content.trigger('gigaset.content.change');
                requestAnimationFrame(onFrame);
            };

            var targetHeight;
            var onAnimationEnd = _.bind(function() {
                endPrecedingAnimation = $.noop;
                content.css('height', '');
                block.bemRemoveModifier(MODIFIER_OPENING);
                block.bemAddModifier(MODIFIER_OPEN);
                cancelAnimationFrame(onFrame);
            }, this);

            block.bemAddModifier(MODIFIER_OPENING);
            if (!isMobile && Animation.supportAnimations) {
                endPrecedingAnimation();
                endPrecedingAnimation = onAnimationEnd;
                content.css('height', 'auto');
                targetHeight = content.height();
                content.css('height', '');
                requestAnimationFrame(onFrame);
                _.defer(_.bind(function() {
                    content.one(Animation.transitionEndEventName, onAnimationEnd);
                    content.css('height', targetHeight);
                }, this));
            } else {
                onAnimationEnd();
            }
        },

        closeItem: function(block, content) {
            var onFrame = function() {
                content.trigger('gigaset.content.change');
                requestAnimationFrame(onFrame);
            };

            var onAnimationEnd = _.bind(function() {
                endPrecedingAnimation = $.noop;
                content.css('height', '');
                block.bemRemoveModifier(MODIFIER_OPEN);
                cancelAnimationFrame(onFrame);
            }, this);

            if (!isMobile && Animation.supportAnimations) {
                endPrecedingAnimation();
                endPrecedingAnimation = onAnimationEnd;
                content.css('height', content.height());
                requestAnimationFrame(onFrame);
                _.defer(_.bind(function() {
                    content.one(Animation.transitionEndEventName, onAnimationEnd);
                    content.css('height', 0);
                }, this));
            } else {
                onAnimationEnd();
            }
        }
    });
});
